/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="filters.module.ts" />

module Meevo.Components.Filters {

  export function meevoRelativeDateFilter($filter: any): any {
    const filter = (input: any) => {
      let output = "";
      if (!input) {
        return output;
      }
      // extract inout date
      let inputDate = input.getDate();
      let inputMonth = input.getMonth();
      let inputYear = input.getFullYear();
      // extract today's date
      let today = new Date();
      let todayDate = today.getDate();
      let todayMonth = today.getMonth();
      let todayYear = today.getFullYear();
      // initialize date filter
      let dateFilter = $filter("date");
      // format date
      if (todayDate === inputDate && todayMonth === inputMonth && todayYear === inputYear) {
        output = dateFilter(input, "shortTime")
      }
      else {
        output = dateFilter(input, "EEE ") + dateFilter(input, "shortDate");
      }
      return output.trim();
    };
    return filter;
  }

  meevoRelativeDateFilter.$inject = ["$filter"];

  angular.module("meevo.components.filters")
    .filter("meevoRelativeDate", meevoRelativeDateFilter);
}
